import { StaffRole } from './roles';

/**
 * Dev-only login: requests go through the vite proxy straight to subgraphs with x-user-id / x-user-role.
 * `import.meta.env.DEV` is false in production builds, so this is compiled out of the shipped bundle.
 */
export const devBypassEnabled = import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH === 'bypass';

export interface DevSession {
  userId: string;
  role: StaffRole;
  name: string;
}

const KEY = 'meradiya.admin.dev-session';

export function getDevSession(): DevSession | null {
  if (!devBypassEnabled) return null;
  try {
    // ?dev_role=admin|manager|viewer signs in directly (handy for screenshots / e2e in dev)
    const fromUrl = new URLSearchParams(window.location.search).get('dev_role');
    if (fromUrl === 'admin' || fromUrl === 'manager' || fromUrl === 'viewer') {
      const s: DevSession = { userId: (new URLSearchParams(window.location.search).get('dev_user') ?? '00000000-0000-4000-8000-000000000001'), role: fromUrl, name: `Dev ${fromUrl}` };
      sessionStorage.setItem(KEY, JSON.stringify(s));
      return s;
    }
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as DevSession) : null;
  } catch {
    return null;
  }
}

export function setDevSession(s: DevSession | null): void {
  try {
    if (s) sessionStorage.setItem(KEY, JSON.stringify(s));
    else sessionStorage.removeItem(KEY);
  } catch {
    /* storage unavailable */
  }
}
